import { gql } from '@apollo/client';

/**
 * Query to fetch the currently authenticated user's own profile.
 * currentUserProfile is a top-level root — separate from currentCustomer.
 * Includes personal details, active status, and assigned roles.
 * Use network-only since the logged-in user's profile may change.
 */
export const GET_CURRENT_USER_PROFILE_QUERY = gql`
	query getCurrentUserProfile {
		currentUserProfile {
			createdAt
			email
			firstName
			id
			identifier
			isActive
			lastName
			phoneNumber
			updatedAt
			roles {
				assignedAt
				claimName
				description
				displayName
				groupingName
			}
		}
	}
`;
